import roundToGivenDecimals from './roundToGivenDecimals';

// BTC amounts carry 8 decimals (1 sat = 1e-8 BTC). Always format with full
// satoshi precision so small amounts don't round to 0 — the default 2-decimal
// rounding rendered a real 0.002 BTC payout as "0" on the Funds page. Use this
// everywhere a BTC value is displayed; never call roundToGivenDecimals directly
// for money.
const formatBtc = (value: string | number): number =>
  roundToGivenDecimals(parseFloat(String(value)), 8);

export default formatBtc;
